import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import * as echarts from 'echarts';
import 'element-ui/lib/theme-chalk/index.css';

import {postKeyValueRequest} from "./utils/api.js";
import {postRequest} from './utils/api.js';
import {putRequest} from './utils/api.js'
import {getRequest} from './utils/api.js'
import {deleteRequest} from './utils/api.js'
import {initMenu} from './utils/menus.js'
import {initSites} from './utils/sites.js'
import {timerSite} from './utils/sites.js'
import 'font-awesome/css/font-awesome.min.css'
import { Message } from 'element-ui';
import JsonExcel from 'vue-json-excel'
import BaiduMap from 'vue-baidu-map'


Vue.prototype.postKeyValueRequest=postKeyValueRequest;
Vue.prototype.postRequest=postRequest;
Vue.prototype.putRequest=putRequest;
Vue.prototype.getRequest=getRequest;
Vue.prototype.deleteRequest=deleteRequest;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('downloadExcel', JsonExcel);
Vue.prototype.$echarts = echarts

  
router.beforeEach((to,from,next)=>{
	 document.title = '水质在线监测信息系统';
	if(to.path=='/'){
		next();
	}else{
		
		if (window.sessionStorage.getItem("user")) {
			initMenu(router, store);
			initSites(store);
			if(sessionStorage.getItem('flag')==0||sessionStorage.getItem('flag')==null){
				sessionStorage.setItem("path",to.path);
				
			}
			if(to.path=="/sys/syspw")
			{
				clearTimeout(sessionStorage.getItem("timeId"));
				sessionStorage.setItem("timeId","null");
			}else{
				if(sessionStorage.getItem("timeId")=="null")
				sessionStorage.setItem("timeId",timerSite(store));
			}			
			// else{
			// 	sessionStorage.setItem('flag',0)
			// 	let path=sessionStorage.getItem('path');
				
			// 	router.push(path);
				
			// }
		   // sessionStorage.path=to.path;
			console.log(to.path);
			
			
			//router.push({path:sessionStorage.path})
			next();
			window.addEventListener('beforeunload',()=>{
			
			sessionStorage.setItem('flag',1)
		  })
			//else
		    
			
		} else {
			Message.error({message:"尚未登陆，请登陆"});
		    next('/?redirect=' + to.path);
		}
	}
	
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
